"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAnyAncestorBindingConstraintsWithServiceId = isAnyAncestorBindingConstraintsWithServiceId;
const isAnyAncestorBindingConstraints_1 = require("./isAnyAncestorBindingConstraints");
const isBindingConstraintsWithServiceId_1 = require("./isBindingConstraintsWithServiceId");
function isAnyAncestorBindingConstraintsWithServiceId(serviceId) {
    return (0, isAnyAncestorBindingConstraints_1.isAnyAncestorBindingConstraints)((0, isBindingConstraintsWithServiceId_1.isBindingConstraintsWithServiceId)(serviceId));
}
//# sourceMappingURL=isAnyAncestorBindingConstraintsWithServiceId.js.map